import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpireMatch} from '@tisa-group/models';

import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class MatchService implements CrudService<UmpireMatch> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatch>> {
    return this.http
      .get(`/matches/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireMatch[]>> {
    return this.http
      .get('/matches', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/matches/${id}`);
  }

  create(
    body: Partial<UmpireMatch>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatch>> {
    return this.http
      .post<JsonApiResponse<UmpireMatch>>('/matches', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireMatch>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatch>> {
    return this.http
      .patch<JsonApiResponse<UmpireMatch>>(
        `/matches/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
